module.exports = "mutation UpdateDashboardWidgets($widgets:[String]){updateDashboardWidgets(widgets:$widgets){success}}"